module.exports = __webpack_public_path__ + "img/7_82.b5c2c4b5.png";